import { Clickable, Col, Text } from 'components';
import { RemoveButton } from 'screens/Admin/components';
import styled from 'styled-components';

const ContentImg = styled.img`
  flex: 1;
  min-height: 225px;
  max-height: 225px;
  background-repeat: no-repeat;
  background-position: center;
  object-fit: contain;
`;

const WebsiteView = ({ metaData, dimensions, remove }) => {
  const { title, description, url, image, icon } = metaData;
  const contentDimms = dimensions || '552px';

  return (
    <Col>
      <Text marg="24px 16px 5px" b2 med>
        Link
      </Text>

      <Col pos="relative">
        <RemoveButton onClick={remove} />

        <Clickable wid={contentDimms} onClick={() => window.open(url, '_blank')}>
          <Col>
            <ContentImg src={image || icon} resizeMode="contain" />

            <Text med marg="12px 0 0" wid={contentDimms}>
              {title}
            </Text>

            <Text wid={contentDimms} marg="4px 0 0" numberOfLines={2} c1>
              {description}
            </Text>
          </Col>
        </Clickable>
      </Col>
    </Col>
  );
};

export default WebsiteView;
